import {
  getSystemState,
  setSystemState,
  subscribeSystemState,
} from "./SystemState";

// NapflixOS Ambient Runtime v5
// Runtime state foundation only. No ambient UI is rendered here.
let ambientState = {
  enabled: true,
  active: false,
  reason: null,
  activatedAt: null,
  lastExitedAt: null,
};

const listeners = new Set();

export function getAmbientState() {
  return ambientState;
}

export function setAmbientState(partial) {
  ambientState = {
    ...ambientState,
    ...partial,
  };

  listeners.forEach((listener) => listener(ambientState));
}

export function subscribeAmbientState(listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

const syncAmbientFromSystemState = (systemState) => {
  if (!systemState.isNapflixOS || !ambientState.enabled) {
    if (ambientState.active) {
      setAmbientState({
        active: false,
        reason: null,
        lastExitedAt: Date.now(),
      });
      setSystemState({ ambientMode: false });
    }

    return;
  }

  if (systemState.isIdle && !ambientState.active) {
    setAmbientState({
      active: true,
      reason: "idle",
      activatedAt: Date.now(),
    });
    setSystemState({ ambientMode: true });
    return;
  }

  if (!systemState.isIdle && ambientState.active) {
    setAmbientState({
      active: false,
      reason: null,
      lastExitedAt: Date.now(),
    });
    setSystemState({ ambientMode: false });
  }
};

export function installAmbientManager() {
  if (typeof window === "undefined" || !getSystemState().isNapflixOS) {
    return () => {};
  }

  syncAmbientFromSystemState(getSystemState());
  return subscribeSystemState(syncAmbientFromSystemState);
}
